angular.module('app.myHockeyTv.watchClips.watchClipsService', [])
  .factory('app.myHockeyTv.watchClips.watchClipsService', [
    '$http',
    function ($http) {
      'use strict';

      return {
        retrieve: function () {
          return $http.get(window.location.api('clips_features'))
            .then(function (response) {
              return response.data;
            });
        }
      };
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/myHockeyTv/watchClips/watchClipsService.js